// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"9fe56c40","453":"9c8ed486","661":"607ae6e3"}[chunkId] + ".chunk.js";
};